import React from "react";
import { connect } from "react-redux";

import { getUserLocation, getUserLocations } from "../../redux/auth";
import { HubFilterMenu } from "../../components";
import { FOUNDRIES } from "../../constants";

const ContactsLocationFilter = ({
  primaryLocation,
  locations,
  multiSelect = true,
  ...rest
}) => {
  const defaultValue = multiSelect
    ? locations?.map((l) => `${l}`)
    : [`${primaryLocation}`];

  return (
    <HubFilterMenu
      id="location"
      options={FOUNDRIES}
      menuLabel="Filter Contacts By Their Location"
      label="Location"
      defaultValue={defaultValue}
      multiSelect={multiSelect}
      {...rest}
    />
  );
};

const mapStateToProps = (state) => ({
  primaryLocation: getUserLocation(state),
  locations: getUserLocations(state),
});

export default connect(mapStateToProps)(ContactsLocationFilter);
